import { createGenericContext } from '@luna/context';

import type { CardsSandbox } from './CardsSandbox';

export const { createContextProvider: createCardsContextProvider, useContext: useCardContext } =
    createGenericContext<CardsSandbox>();
